import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'app-tip-boolean',
	templateUrl: './tip-boolean.component.html',
	styleUrls: ['./tip-boolean.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TipBooleanComponent {
	@Input() textTrue: string = 'Yes';
	@Input() textFalse: string = 'No';

	@Input()
	public set value(value: boolean) {
		this._value = value;
		this.setBadgeClass();
	}

	@Input()
	public set isInvertedColors(isInverted: boolean) {
		this._isInverted = isInverted;
		this.setBadgeClass();
	}

	private _isInverted: boolean;
	private _value: boolean;
	private _class: string;

	public get isValueSet(): boolean {
		return this._value === true || this._value === false;
	}

	public get value(): boolean {
		return this._value;
	}

	public get class(): string {
		return this._class;
	}

	private setBadgeClass(): void {
		if (!this.isValueSet) {
			return;
		}
		if ((this._value && !this._isInverted) || (!this._value && this._isInverted)) {
			this._class = 'badge-success';
		} else {
			this._class = 'badge-danger';
		}
	}
}
